import * as Sentry from '@sentry/react';

import { MixpanelEvents, setMixpanelUserPropertiesOnce } from '@/shared/thirdParty/mixpanel';
import { User } from '@/shared/types/User';

import type { TrialPaywallVariant } from '../lib/types';

import { computeTrialPaywallVariant } from '../lib/computeTrialPaywallVariant';
import { TRIAL_PAYWALL_VARIANT_KEY } from '../lib/constants';
import { isExcludedFromTrialPaywall } from '../lib/eligibility';
import { persistTrialPaywallVariant } from './persistTrialPaywallVariant';
import { useTrialPaywallVariantStore } from './useTrialPaywallVariantStore';

type AssignTrialPaywallVariantParams = {
  user: Pick<User, 'country' | 'id'>;
};

export const assignTrialPaywallVariant = ({ user }: AssignTrialPaywallVariantParams): null | TrialPaywallVariant => {
  if (isExcludedFromTrialPaywall() || !user.country) return null;

  try {
    const { setAssignment } = useTrialPaywallVariantStore.getState();
    const variant = computeTrialPaywallVariant(user.id, user.country);

    setAssignment({ userId: user.id, variant });

    MixpanelEvents.variant_trial_paywall({ variant });
    setMixpanelUserPropertiesOnce({ [TRIAL_PAYWALL_VARIANT_KEY]: variant });

    void persistTrialPaywallVariant(variant);

    return variant;
  } catch (error) {
    Sentry.captureException(error, { tags: { feature: 'trialPaywallVariant', phase: 'assign' } });
    return null;
  }
};
